export const REMOVE = 'REMOVE'
export const INCREASE = 'INCREASE'
export const DECREASE = 'DECREASE'
export const ADD_TO_CART = 'ADD_TO_CART'
export const CLEAR_CART = 'CLEAR_CART'
